import { useUpdateUserLanguageMutation } from './UpdateUserLanguageMutation.generated';

const useUpdateUserLanguage = () => {
  const [update] = useUpdateUserLanguageMutation();
  const updateUserLanguage = async (language: LanguageCode) =>
    update({ variables: { input: { language } } });
  return updateUserLanguage;
};

export default useUpdateUserLanguage;
